// extracted by mini-css-extract-plugin
export var gallery = "styles-module--gallery--6a1a2";
export var galleryDesktop = "styles-module--gallery-desktop--41e6c";
export var galleryMiniImage = "styles-module--gallery-mini-image--7f5fd";
export var galleryMobile = "styles-module--gallery-mobile--d0a2a";
export var navigationButtons = "styles-module--navigation-buttons--4163b";
export var video = "styles-module--video--d8200";